import { AbstractControl, ValidationErrors } from "@angular/forms";

export function emailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control?.value) return null;

    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ui
    return regex.test(control.value) ? null : { 'email': true };
}

export function englishCharactersOnlyValidator(control: AbstractControl): ValidationErrors | null {
    if (!control?.value) return null;

    const regex = /^[\p{Script=Latin} -]+$/ui;
    return regex.test(control.value) ? null : { 'englishCharactersOnly': true };
}